<template>
  <div class="wrap">
    <h3 class="title">富裕钱包产品服务协议</h3>
    <p>
      甲方:北京付裕数字科技有限公司富裕钱包服务的用户
    </p>
    <p style="margin-bottom:20px">
      乙方:北京付裕数字科技有限公司
    </p>
    <div>
        一、特别声明
    </div>
    <div>
        1、在您注册成为富裕钱包用户以接受本服务条款之前，您已充分阅读、理解并接受本服务的全部内容，一旦您使用本服务，即表示您同意遵循本服务之所有约定。
    </div>
    <p>
        2、乙方有权对本服务内容进行单方面的变更，并以公告方式在富裕钱包应用内予以公布，无需另行通知;若您在本服务内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的服务內容，也将遵循修改后的服务內容使用本服务;若您不同意修改后的服务内容，您应立即停止使用本服务。
    </p>
    <p>
        3、基于运行和服务安全的需要，乙方可以暂时停止提供或者限制本服务部分功能，在任何功能減少、增加或者变化时，如您继续使用本服务，视为您同意接受本服务及变更后的服务;如您不同意本服务及变更后的服务，您应立即停止使用本服务。
    </p>
    <p class="">
        4、在您同意接受本服务并成功注册为富裕钱包用户时，您是具备完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人，且本服务内容符合您所属国家或地区的法律规定。不具备前述条件的，您应立即终止注册或停止使用本服务，否则，乙方有权自行终止您所使用的所有服务。
    </p>
    <p  class="">
        二、甲方的权利与义务
    </p>
    <p>
        1、遵守国家机关和行业管理机构制定的相关法律、法规和行业规范，不得将本服务用于任何非法目的(包括用于禁止或限制物品的交易)，也不能以任何非法方式使用本服务。
    </p>
    <p>
        2、甲方承诺向乙方提供的基本信息、营业执照影印件、法定代表人或负责人身份证影印件等各类证件信息均真实、合法、有效。
    </p>
    <div class="subTitle">
        3、当甲方提供的信息发生变更时，至少应自变更之日起5个工作日内书面通知乙方，并提供相关资料。如因甲方未及时履行上述责任而造成的损失，由甲方承担。
    </div>
    <p>
        4、如因甲方未按规定提交申请资料导致乙方无法进行处理引起的纠纷或法律诉讼，由甲方承担相关责任。
    </p>
    <p>
        5、甲方不得利用本服务从事侵害他入合法权益之行为，以及进行任何违法或不正当的活动，否则乙方有权拒绝提供本服务，且您应承担因此产生的一切责任;造成乙方受损的，您应承担损害赔偿责任。上述行为包括但不限于:
    </p>
    <p>
        v侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益。
    </p>
    <p>
        v违反依法定或约定之保密协议的。
    </p>
    <p class="">
        v从事不法交易行为，如洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品以及其他乙方认为不得使用本服务进行交易的物品等。
    </p>
    <div class="">
        v非法使用他人银行账号(包括信用卡账号)或无效银行账号(包括信用卡账号)
    </div>
    <p class="">
        v其乙方有正当理由认为不适当之行为。
    </p>
    <p class="">
        6、甲方应妥善保管在乙方注册的用户名称及密码，因甲方用户名称和密码保管及使用不当造成的经济损失，由甲方自行承担，与乙方无关。
    </p>
    <p class="">
        7、甲方应充分了解并清楚知晓出租、出借、出售、够买账户的相关法律责任和惩戒措施，承诺依法依规开立和使用甲方账户。否则，甲方应承担由此引起的一切法律责任和后果，乙方并有权据此终止本协议。
    </p>
    <div class="">
        三、乙方的权利与义务
    </div>
    <p class="">
        1、遵守国家机关制定的相关法律、法期、运作規章以及相关规定。
    </p>
    <p class="">
        2、乙方有权基于单方独立判断，包含但不限于乙方认为您已经违反本服务条款的规定，暂停、中断或终止向您提供富裕钱包服务(或其任何部分)。
    </p>
    <p>
        3、甲方出现下列任一种情形时，乙方有权立即终止甲方的服务，并关闭账户权限，单方面无条件终止本协议，由此给乙方造成的相关损失和风险责任由甲方承担。乙方有权根据风险管理规定，使用甲方的相关风险信息。
    </p>
    <p>
        1)虚假申请:以虚假资料或冒用其它用户的资料向乙方申请为富裕钱包用户;
    </p>
    <p>
        2)恶意倒闭:甲方接受故意破产，使乙方承担经济损失;
    </p>
    <p class="">
        3)被工商部门注销登记、吊销营业执照;由于违反国家法令、法规或相关行业管理规定，被有关机构查处;
    </p>
    <p class="">
        4)甲方和/或甲方法人代表或其主要负责人涉及重大民事纠纷或涉嫌重大经济、刑事犯罪;
    </p>
    <p class="">
        5)因经营不善，导致停业整顿、倒闭的;
    </p>
    <p class="">
       6)其它违反本协议的行为。
    </p>
    <p class="">
        4、本协议终止后24个月内，乙方对本协议终止前的交易仍有向甲方查询及追索的权利，法律另有规定的除外。
    </p>
    <p class="">
        四、产品服务相关的权利及义务
    </p>
    <p class="">
       1、服务费:甲方使用乙方提供的富裕钱包产品服务，乙方会向甲方收取服务费用；
    </p>
    <p class="">
       2、服务费调整:乙方将以公告方式在富裕钱包客户端予以公布，无需另行通知;若甲方在服务费调整后继续使用本服务的，视为甲方接受服务费的调整。
    </p>
    <p class="">
       五、隐私保护
    </p>
    <p class="">
       1、在甲方同意本协议或使用富裕钱包服务之日起，甲方即同意乙方按照以下条款来使用和披露其个人或企业信息。
    </p>
    <p class="">
       2、乙方所提供的服务将需要甲方提供其银行账户信息，在甲方提供相应信息后，乙方将严格履行相关保密约定。
    </p>
    <p class="">
        3、为了保障甲方使用富裕钱包服务的安全以及不断改进服务质量，乙方将记录并保存甲方登录和使用富裕钱包服务的相关信息，但乙方承诺不将此类信息提供给除富裕钱包外的其他任何第三方(除双方另有约定或法律法规另有规定外)。
    </p>
    <p class="">
        4、甲方了解并同意，乙方为了保障数据安全，有权收集硬件的位置信息，并在发生可疑数据时通过富裕钱包客户端采用技术手段收集相关信息。
    </p>
    <p class="">
       5、富裕钱包客户端可能会链接第三方服务，乙方会要求第三方保护用户隐私，但乙方对第三方的隐私保护措施不负责任。
    </p>
    <p class="">
       6、乙方仅按现有技术提供相应的安全措施来使其掌握的信息不丢失、不被滥用和变造，这些安全措施包括向其它服务器备份数据、对信息加密;尽管有这些安全措施，但乙方不保证这些信息的绝对安全。
    </p>
    <p class="">
        六、免责条款
    </p>
    <p class="">
        1、除本协议及其附件中已另有规定者外，任何一方如因未能完全履行其在本协议项下的责任和义务，造成其它方损失的，应负责赔偿其它方因此而产生的直接损失、损害，并承担由此造成的责任和/或开支。
    </p>
    <p class="">
        2、任何一方如因未能完全履行其在本协议项下的责任和义务，导致本协议无法继续履行或继续履行没有实际意义时，其它方有权解除协议并要求违约方承担相应的违约责任。
    </p>
    <p class="">
        3、发生暴雨、地震、泥石流、台风、战争、内乱等不可抗力事件影响本协议的履行，且该等事件持续时间超过60日，则任何一方有权书面通知对方终止本协议，双方对因此而造成的损失不承担任何责任。
    </p>
    <p class="">
       4、本协议的终止不影响双方在协议终止前已按本协议条款累积的权利和义务;终止发生时，双方应相互结清根据本协议规定应付未付的各项款项。
    </p>
    <p class="">
        5、双方一致同意，除有关法律、法规规定或有管辖权的政府有关机关要求外，未经本协议双方的事先书面同意，任何一方及其雇员(包括因履行本协议而聘请的专业顾问、中介机构、代理人和/或双方的母公司、关联公司及投资人)应对其已获得但尚未公开的、与本协议相关的所有资料和文件(无论是财务、技术或其它方面的资料和文件)承担保密义务，不得向任何其它方和公众透露上述保密信息。该保密条款的有效期不受本协议有效期影响、永久有效。
    </p>
    <p class="">
        七、服务条款的解释、法律适用及争端解决
    </p>
    <p class="">
        第七条 免责声明
    </p>
    <p class="">
        1、乙方对本服务条款拥有最终的解释权。
    </p>
    <p class="">
        2、本协议及其修订本的效力、解释、履行、争议解决和本协议及其修订本效力有关的所有事宜，均适用中华人民共和国法律（不包含香港、澳门和台湾的法律法规）。
    </p>
    <p class="">
        3、任何本平台之外的第三方机构或个人所提供的服务，其服务品质及内容、纠纷由该第三方自行、独立负责，与本平台无关。
    </p>
    <p class="">
        3、因本协议所引起的用户与北京付裕数字科技有限公司的任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交乙方所在地人民法院诉讼解决。
    </p>
    <img src="../../assets/img/backPic.png" alt="" @click="back" class="pic">
  </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        back(){
            this.$router.push({
                name:"share",
                query:{
                    isBack:"0000"
                }
            })
        }
    },
    created() {
        document.title = "用户服务协议"
    },
};
</script>

<style scoped>
.wrap{
    padding: 0 10px;
}
.title{
    text-align: center;
    padding: 10px 0;
}
.weight {
  font-weight: bold;
}
p{
    text-indent: 32px;
    line-height: 28px;
}
.subTitle{
    line-height: 28px;
    margin-top: 10px;
}
.pic{
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
}
</style>